import { useTranslation } from 'next-i18next'

import { LearningProduct } from '~/MathTopics/types/math-topic.type'

interface Props {
  item: LearningProduct
}

export default function MathVaultModules(props: Props): React.ReactElement {
  const { t } = useTranslation('mathTopics')

  const { item } = props

  return (
    <div className="flex flex-col items-center justify-center h-28 px-2 pt-2 pb-4 text-center">
      <div className="h-5 mb-2 last:mb-0 font-normal leading-4 tracking-widest">
        {item.articleCount} {item.articleCount === 1 ? t('entry') : t('entries')}
      </div>
      <div className="h-5 mb-2 last:mb-0 font-normal leading-4 tracking-widest">
        {item.quizCount} {item.quizCount === 1 ? t('quiz') : t('quizzes')}
      </div>
    </div>
  )
}
